import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';

export default {
  ...queryBuilder.properties({
    gardenSize: { type: 'number', maximum: 2147483647, minimum: 1 },
  }),
};
